import { Content, ContentMetadata, SelectedMedia } from '@/lib/model';

export function isVideoContentType(content: Content) {
  return content?.type === 'video';
}

export function isAudioContentType(content: Content) {
  return content?.type === 'audio';
}

export function isVideoContentMetadataType(contentMetadata: ContentMetadata) {
  if (contentMetadata?.type === 'video') {
    return true;
  }
  return contentMetadata?.medias?.find(
    m => (m.media as SelectedMedia)?.media?.type === 'VIDEO',
  );
}

export function isAudioContentMetadataType(contentMetadata: ContentMetadata) {
  if (contentMetadata?.type === 'audio') {
    return true;
  }
  return contentMetadata?.medias?.find(
    m => (m.media as SelectedMedia)?.media?.type === 'AUDIO',
  );
}

export function isShowContentMetadataType(contentMetadata: ContentMetadata) {
  return contentMetadata?.subType === 'tvContent';
}
